import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  FormArray,
  Validators
} from '@angular/forms';
import { DataService } from '../services/data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-diagnostic-quiz',
  templateUrl: './diagnostic-quiz.component.html',
  styleUrls: ['./diagnostic-quiz.component.scss']
})
export class DiagnosticQuizComponent implements OnInit {
  loading = true;
  greeting: string;
  selectedTab = 0;
  questions: any[];
  formStep1: FormGroup;
  formStep2: FormGroup;
  formStep3: FormGroup;
  formStep4: FormGroup;
  formStep5: FormGroup;
  formStep6: FormGroup;
  formStep7: FormGroup;
  messageError = 'El campo es requerido';
  public risk = 0;
  showResults = false;
  saving = false;
  showResultTest = false;
  showResultVihTests = false;
  showWhereOther = false;
  showInfection = false;
  showInfectionOther = false;
  showPartner = false;
  otherId = null;

  constructor(
    private formBuilder: FormBuilder,
    private dataService: DataService,
    private router: Router
  ) { }

  ngOnInit() {
    if (!this.dataService.dataRegistration) {
      this.router.navigate(['/diagnostico']);
    } else {
      if (this.dataService.dataRegistration.anonymous_survey) {
        this.greeting = 'Encuesta anónima';
      } else {
        this.greeting = this.dataService.dataRegistration.name;
      }
    }
    this.formStep1 = this.formBuilder.group({
      sexual_activity: ['', [Validators.required]]
    });

    this.formStep2 = this.formBuilder.group({
      planning_method: ['', [Validators.required]],
      planning_method_explain: [''],
      had_pregnancy: ['', [Validators.required]]
    });

    this.formStep3 = this.formBuilder.group({
      how_many_pregnancies: ['', [Validators.required]],
      had_caesarean: ['', [Validators.required]],
      had_abortions: ['', [Validators.required]],
      had_test: ['', [Validators.required]],
      had_test_period: [''],
      medical_complications: this.formBuilder.array([]),
      pregnancy_problems: this.formBuilder.array([]),
      pregnancy_hospitalization: this.formBuilder.array([])
    });

    this.formStep4 = this.formBuilder.group({
      last_months_activities: this.formBuilder.array([])
    });

    this.formStep5 = this.formBuilder.group({
      chronic_disease: this.formBuilder.array([]),
      chronic_disease_explain: ['', []]
    });

    this.formStep6 = this.formBuilder.group({
      vih_tests: ['', [Validators.required]],
      // vih_tests_resulted: ['', [Validators.required]],
      // syphilis_tests: ['', [Validators.required]],
      // syphilis_tests_resulted: ['', [Validators.required]],
      // infectious_hepatitis: ['', [Validators.required]],
      // had_tuberculosis: ['', [Validators.required]],
      // symptoms_genital_area: this.formBuilder.array([]),

      vih_test_period: [''],
      vih_test_where: [''],
      vih_test_where_other: [''],
      infection_test: ['', [Validators.required]],
      infection_test_type: this.formBuilder.array([]),
      infection_test_other: [''],
      vih_treatment: [''],
      vih_partner: [''],
      has_symptoms: this.formBuilder.array([]),
      vih_orientation: [''],
    });

    this.formStep7 = this.formBuilder.group({
      getting_pregnant: ['', [Validators.required]],
      receive_information: ['', [Validators.required]],
      school_name: ['', [Validators.maxLength(100)]],
      school_address: ['', [Validators.maxLength(100)]]
    });

    this.dataService.getQuestionsAnswers().subscribe(response => {
      this.questions = response;
      this.answerOrder();
      this.searchOtherAnswer();
      this.loading = false;
    });
  }

  selectionChanged(event) {
    if (event.value === 7) {
      this.formStep2
        .get('planning_method_explain')
        .setValidators([Validators.required, Validators.maxLength(150)]);
    } else {
      this.formStep2.get('planning_method_explain').setValidators([]);
    }
    this.formStep2.get('planning_method_explain').updateValueAndValidity();
  }

  onChange(event, field, form) {
    const checks = this[form].get(field) as FormArray;
    if (event.checked && event.source.value === 62) {
      this.formStep5
        .get('chronic_disease_explain')
        .setValidators([Validators.required, Validators.maxLength(150)]);
      this.formStep5.get('chronic_disease_explain').updateValueAndValidity();
    } else {
      this.formStep5.get('chronic_disease_explain').setValidators([]);
      this.formStep5.get('chronic_disease_explain').updateValueAndValidity();
    }
    if (event.checked) {
      checks.push(new FormControl(event.source.value));
    } else {
      const i = checks.controls.findIndex(x => x.value === event.source.value);
      checks.removeAt(i);
    }
  }

  changeReceiveInformation(event) {
    if (event.value === 0) {
      this.formStep7.get('school_name').setValidators([]);
      this.formStep7.get('school_name').updateValueAndValidity();
    } else {
      this.formStep7.get('school_name').setValidators([Validators.required, Validators.maxLength(100)]);
      this.formStep7.get('school_name').updateValueAndValidity();
    }
  }

  onChangeRadio(event, affectedField) {
    if (event.value === 63 || event.value === 68) {
      this.formStep6.get(affectedField).setValidators([Validators.required]);
      this.formStep6.get(affectedField).updateValueAndValidity();
    } else {
      this.formStep6.controls[affectedField].patchValue('');
      this.formStep6.get(affectedField).setValidators([]);
      this.formStep6.get(affectedField).updateValueAndValidity();
    }
  }

  showChronicDisease() {
    const index = this.formStep5.value.chronic_disease.indexOf(62);
    if (index >= 0) {
      return true;
    }
    return false;
  }

  nextTab() {
    this.validateStep();
  }

  backTab() {
    if (this.selectedTab === 3) {
      if (this.formStep1.value.sexual_activity === 1) {
        if (this.formStep2.value.had_pregnancy === 8) {
          this.selectedTab -= 1;
        } else {
          this.selectedTab = 1;
        }
      } else {
        this.selectedTab = 0;
      }
    } else {
      this.selectedTab -= 1;
      if (this.selectedTab <= 0) {
        this.selectedTab = 0;
      }
    }
  }

  markTouched(formName) {
    const form = this[formName];
    for (const item in form.controls) {
      if (form.controls[item]) {
        form.controls[item].markAsTouched();
      }
    }
  }

  validateStep() {
    if (this.selectedTab === 0) {
      if (this.formStep1.valid) {
        if (this.formStep1.value.sexual_activity === 1) {
          this.selectedTab += 1;
        } else {
          this.selectedTab = 3;
        }
      } else {
        this.markTouched('formStep1');
      }
    } else if (this.selectedTab === 1) {
      if (this.formStep2.valid) {
        if (this.formStep2.value.had_pregnancy === 8) {
          this.selectedTab += 1;
        } else {
          this.selectedTab = 3;
        }
      } else {
        this.markTouched('formStep2');
      }
    } else if (this.selectedTab === 2) {
      if (this.formStep3.valid) {
        this.selectedTab += 1;
      } else {
        this.markTouched('formStep3');
      }
    } else if (this.selectedTab === 3) {
      this.selectedTab += 1;
    } else if (this.selectedTab === 4) {
      if (this.formStep5.valid) {
        this.selectedTab += 1;
      } else {
        this.markTouched('formStep5');
      }
    } else if (this.selectedTab === 5) {
      if (this.formStep6.valid) {
        this.selectedTab += 1;
      } else {
        console.log(this.formStep6.controls);
        this.markTouched('formStep6');
      }
    } else if (this.selectedTab === 6) {
      if (this.formStep7.valid) {
        this.save();
      } else {
        this.markTouched('formStep7');
      }
    }
  }

  save() {
    this.showResults = true;
    this.saving = true;
    const registration = this.dataService.dataRegistration;
    registration.receive_information = this.formStep7.value.receive_information;
    if (registration.receive_information === 1) {
      registration.school_name = this.formStep7.value.school_name;
      registration.school_address = this.formStep7.value.school_address;
    }
    const objectAnswers = {
      questions: [
        { question_id: 1, answers: [this.formStep1.value.sexual_activity] },
        { question_id: 2, answers: [this.formStep2.value.planning_method], detail: {} },
        { question_id: 3, answers: [this.formStep2.value.had_pregnancy] },
        { question_id: 4, answers: [this.formStep3.value.how_many_pregnancies] },
        { question_id: 5, answers: [this.formStep3.value.had_caesarean] },
        { question_id: 6, answers: [this.formStep3.value.had_abortions] },
        { question_id: 20, answers: [this.formStep3.value.had_test] },
        { question_id: 21, answers: [this.formStep3.value.had_test_period] },
        { question_id: 7, answers: [...this.formStep3.value.medical_complications] },
        { question_id: 8, answers: [...this.formStep3.value.pregnancy_problems] },
        { question_id: 9, answers: [...this.formStep3.value.pregnancy_hospitalization] },
        { question_id: 10, answers: [...this.formStep4.value.last_months_activities] },
        {
          question_id: 11,
          answers: [...this.formStep5.value.chronic_disease],
          detail: {}
        },
        { question_id: 12, answers: [this.formStep6.value.vih_tests] },
        // { question_id: 13, answers: [this.formStep6.value.vih_tests_resulted] },
        // { question_id: 14, answers: [this.formStep6.value.syphilis_tests] },
        // { question_id: 15, answers: [this.formStep6.value.syphilis_tests_resulted] },
        // { question_id: 16, answers: [this.formStep6.value.infectious_hepatitis] },
        // { question_id: 17, answers: [this.formStep6.value.had_tuberculosis] },
        // { question_id: 18, answers: [...this.formStep6.value.symptoms_genital_area] },
        { question_id: 19, answers: [this.formStep7.value.getting_pregnant] },
        { question_id: 22, answers: [this.formStep6.value.vih_test_period] },
        // {
        //   question_id: 23,
        //   answers: [this.formStep6.value.vih_test_where],
        //   detail: {
        //     answer_id: this.formStep6.value.vih_test_where,
        //     text: this.formStep6.value.vih_test_where_other
        //   }
        // },
        { question_id: 24, answers: [this.formStep6.value.infection_test] },
        {
          question_id: 25,
          answers: this.formStep6.value.infection_test_type,
          // detail: {
          //   answer_id: this.formStep6.value.infection_test_type,
          //   text: this.formStep6.value.infection_test_other
          // }
        },
        { question_id: 26, answers: [this.formStep6.value.vih_treatment] },
        { question_id: 27, answers: [this.formStep6.value.vih_partner] },
        { question_id: 28, answers: [...this.formStep6.value.has_symptoms] },
        { question_id: 29, answers: [this.formStep6.value.vih_orientation] },
      ],
      registration
    };

    if (objectAnswers.questions[1].answers[0] === 7) {
      objectAnswers.questions[1].detail = {
        answer_id: 7,
        text: this.formStep2.value.planning_method_explain
      };
    }
    const index = objectAnswers.questions[10].answers.indexOf(62);
    if (index >= 0) {
      objectAnswers.questions[10].detail = {
        answer_id: 62,
        text: this.formStep5.value.chronic_disease_explain
      };
    }

    let hasOtherAnswer = this.formStep6.value.infection_test_type.find(i => i == this.otherId);
    if (hasOtherAnswer) {
      let question = objectAnswers.questions.find(q => q.question_id == 25);
      question.detail = {
        answer_id: this.otherId,
        text: this.formStep6.value.infection_test_other
      }
    }

    let otherOption = this.formStep5.value.chronic_disease.indexOf(62);
    if (otherOption >= 0) {
      let question = objectAnswers.questions.find(q => q.question_id == 11);
      question.detail = {
        answer_id: 62,
        text: this.formStep5.value.chronic_disease_explain
      }
    }

    this.dataService.storePoll(objectAnswers).subscribe(
      data => {
        this.saving = false;
        if (data && data.max_risk >= 0) {
          this.risk = data.max_risk;
        }
      },
      error => {
        console.log(error);
        this.saving = false;
      }
    );
  }

  get sexual_activity() {
    return this.formStep1.get('sexual_activity');
  }
  get planning_method() {
    return this.formStep2.get('planning_method');
  }
  get had_pregnancy() {
    return this.formStep2.get('had_pregnancy');
  }
  get how_many_pregnancies() {
    return this.formStep3.get('how_many_pregnancies');
  }
  get had_caesarean() {
    return this.formStep3.get('had_caesarean');
  }
  get had_abortions() {
    return this.formStep3.get('had_abortions');
  }
  get had_test() {
    return this.formStep3.get('had_test');
  }
  get had_test_period() {
    return this.formStep3.get('had_test_period');
  }
  get chronic_disease() {
    return this.formStep5.get('chronic_disease');
  }
  get vih_tests() {
    return this.formStep6.get('vih_tests');
  }
  // get vih_tests_resulted() {
  //   return this.formStep6.get('vih_tests_resulted');
  // }
  // get syphilis_tests() {
  //   return this.formStep6.get('syphilis_tests');
  // }
  // get syphilis_tests_resulted() {
  //   return this.formStep6.get('syphilis_tests_resulted');
  // }
  // get infectious_hepatitis() {
  //   return this.formStep6.get('infectious_hepatitis');
  // }
  // get had_tuberculosis() {
  //   return this.formStep6.get('had_tuberculosis');
  // }
  get vih_test_period() {
    return this.formStep6.get('vih_test_period');
  }
  get vih_test_where() {
    return this.formStep6.get('vih_test_where');
  }
  get infection_test() {
    return this.formStep6.get('infection_test');
  }
  get infection_test_type() {
    return this.formStep6.get('infection_test_type');
  }
  get vih_treatment() {
    return this.formStep6.get('vih_treatment');
  }
  get vih_partner() {
    return this.formStep6.get('vih_partner');
  }
  get has_symptoms() {
    return this.formStep6.get('has_symptoms');
  }
  get vih_orientation() {
    return this.formStep6.get('vih_orientation');
  }
  get getting_pregnant() {
    return this.formStep7.get('getting_pregnant');
  }
  get receive_information() {
    return this.formStep7.get('receive_information');
  }
  get school_name() {
    return this.formStep7.get('school_name');
  }
  get school_address() {
    return this.formStep7.get('school_address');
  }

  answerOrder() {
    let questionIndex = this.questions.findIndex(q => q.question == "¿Padeces alguna enfermedad crónica de las siguientes?");
    if (questionIndex) {
      let questionTMP = this.questions[questionIndex];
      let answers = questionTMP.answers.filter(a => a.answer != 'Otras');
      let finalAnswer = questionTMP.answers.find(a => a.answer == 'Otras');
      this.questions[questionIndex].answers = answers;
      this.questions[questionIndex].answers.push(finalAnswer);
    }
  }

  setHadTest(answer) {
    if (answer.answer == 'Sí' || answer.answer == 'Si') {
      this.showResultTest = true;
      this.formStep3
        .get("had_test_period")
        .setValidators([Validators.required]);
    }
    else {
      this.formStep3.get("had_test_period").clearValidators();
      this.formStep3.get("had_test_period").setValue('');
      this.showResultTest = false;
    }
    this.formStep3.get('had_test_period').updateValueAndValidity();
  }

  setVihTests(answer) {
    if (answer.answer == 'Sí' || answer.answer == 'Si') {
      this.showResultVihTests = true;
      this.formStep6.get("vih_test_period").setValidators([Validators.required]);
      // this.formStep6.get("vih_test_where").setValidators([Validators.required]);
    }
    else {
      this.formStep6.get("vih_test_period").clearValidators();
      // this.formStep6.get("vih_test_where").clearValidators();
      this.showResultVihTests = false;
      this.formStep6.get("vih_test_period").setValue('');
      // this.formStep6.get("vih_test_where").setValue('');
      this.showWhereOther = false;
      // this.formStep6.get("vih_test_where_other").clearValidators();
      // this.formStep6.get("vih_test_where_other").setValue('');
    }
    this.formStep6.get('vih_test_period').updateValueAndValidity();
    // this.formStep6.get('vih_test_where').updateValueAndValidity();
  }

  setVihTestsWhere(answer) {
    // if (answer.answer == 'Otro' || answer.answer == 'otro') {
    //   this.showWhereOther = true;
    //   this.formStep6.get("vih_test_where_other").setValidators([Validators.required]);
    // }
    // else {
    //   this.showWhereOther = false;
    //   this.formStep6.get("vih_test_where_other").clearValidators();
    //   this.formStep6.get("vih_test_where_other").setValue('');
    // }
    // this.formStep6.get('vih_test_where_other').updateValueAndValidity();
  }

  setTreatment(answer) {
    if (answer.answer == 'Sí' || answer.answer == 'Si') {
      this.showPartner = true;
      this.formStep6.get("vih_partner").setValidators([Validators.required]);
    }
    else {
      this.showPartner = false;
      this.formStep6.get("vih_partner").clearValidators();
      this.formStep6.get("vih_partner").setValue('');
    }
    this.formStep6.get('vih_partner').updateValueAndValidity();
  }

  setInfectionTest(answer) {
    if (answer.answer == 'Sí' || answer.answer == 'sí') {
      this.showInfection = true;
      this.formStep6.get("infection_test_type").setValidators([Validators.required]);
      this.formStep6.get("vih_treatment").setValidators([Validators.required]);
    }
    else {
      this.showInfection = false;
      this.formStep6.get("infection_test_type").clearValidators();
      this.formStep6.get("vih_treatment").clearValidators();
      this.showInfectionOther = false;
      (<FormArray>this.formStep6.get('infection_test_type')).clear();
      this.formStep6.get("vih_treatment").setValue('');
      this.formStep6.get("infection_test_other").clearValidators();
      this.formStep6.get("infection_test_other").setValue('');
      this.showPartner = false;
      this.formStep6.get("vih_partner").clearValidators();
      this.formStep6.get("vih_partner").setValue('');
    }
    this.formStep6.get('infection_test_type').updateValueAndValidity();
    this.formStep6.get('vih_treatment').updateValueAndValidity();
  }

  setInfectionTestOther(event, field, form) {
    const checks = this[form].get(field) as FormArray;
    if (event.checked) {
      checks.push(new FormControl(event.source.value));
    } else {
      const i = checks.controls.findIndex(x => x.value === event.source.value);
      checks.removeAt(i);
    }

    if (this.otherId) {
      if (checks.value.find(i => i == this.otherId)) {
        this.showInfectionOther = true;
        this.formStep6.get("infection_test_other").setValidators([Validators.required]);
      }
      else {
        this.showInfectionOther = false;
        this.formStep6.get("infection_test_other").clearValidators();
      }
      this.formStep6.get('infection_test_other').updateValueAndValidity();
    }
  }

  searchOtherAnswer() {
    this.otherId = this.questions[24].answers.find(q => q.answer == "Otra").id;
  }
}
